/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDiff = createReactComponent("outline", "arrows-diff", "IconArrowsDiff", [["path", { "d": "M11 16h10", "key": "svg-0" }], ["path", { "d": "M11 16l4 4", "key": "svg-1" }], ["path", { "d": "M11 16l4 -4", "key": "svg-2" }], ["path", { "d": "M13 8h-10", "key": "svg-3" }], ["path", { "d": "M13 8l-4 4", "key": "svg-4" }], ["path", { "d": "M13 8l-4 -4", "key": "svg-5" }]]);

export { IconArrowsDiff as default };
//# sourceMappingURL=IconArrowsDiff.mjs.map
